export const style = {
  dialogTitle: {
    padding: 0,
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
  },
  titleVariant: 'h5',
  closeIcon: {
    marginLeft: '1rem',
  },
} as const;
